import { queryOptions, useQuery } from '@tanstack/react-query';
import { getValidated } from '@shared/api';
import { planUsageKeys } from './keys';
import { PlanUsageResponseSchema } from './schemas';
import { toPlanUsage } from './mappers';
import type { PlanUsageModel } from '../model/types';

export const planUsageQueryOptions = queryOptions({
  queryKey: planUsageKeys.detail(),
  queryFn: () => getValidated('api/v1/subscription/plan-usage', PlanUsageResponseSchema),
  select: (res): PlanUsageModel | null => (res.data ? toPlanUsage(res.data) : null),
  staleTime: 5 * 60 * 1000,
});

export function usePlanUsage() {
  return useQuery(planUsageQueryOptions);
}
